function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#F5F4F7",
  d: "M49.6 41.701H27.2c-.883 0-1.6-.717-1.6-1.6v-32c0-.883.717-1.6 1.6-1.6h22.4c.883 0 1.6.717 1.6 1.6v32c0 .883-.717 1.6-1.6 1.6z",
  transform: "translate(-477 -343) translate(477 343)"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#8D89AA"
}, /*#__PURE__*/React.createElement("path", {
  d: "M8 3.201H1.6c-.883 0-1.6-.717-1.6-1.6 0-.883.717-1.6 1.6-1.6H8c.883 0 1.6.717 1.6 1.6 0 .883-.717 1.6-1.6 1.6zM8 9.601H1.6c-.883 0-1.6-.717-1.6-1.6 0-.883.717-1.6 1.6-1.6H8c.883 0 1.6.717 1.6 1.6 0 .883-.717 1.6-1.6 1.6zM8 16.001H1.6c-.883 0-1.6-.717-1.6-1.6 0-.883.717-1.6 1.6-1.6H8c.883 0 1.6.717 1.6 1.6 0 .883-.717 1.6-1.6 1.6zM8 22.401H1.6c-.883 0-1.6-.717-1.6-1.6 0-.883.717-1.6 1.6-1.6H8c.883 0 1.6.717 1.6 1.6 0 .883-.717 1.6-1.6 1.6zM17.6 3.201h-3.2c-.883 0-1.6-.717-1.6-1.6 0-.883.717-1.6 1.6-1.6h3.2c.883 0 1.6.717 1.6 1.6 0 .883-.717 1.6-1.6 1.6zM17.6 9.601h-3.2c-.883 0-1.6-.717-1.6-1.6 0-.883.717-1.6 1.6-1.6h3.2c.883 0 1.6.717 1.6 1.6 0 .883-.717 1.6-1.6 1.6zM17.6 16.001h-3.2c-.883 0-1.6-.717-1.6-1.6 0-.883.717-1.6 1.6-1.6h3.2c.883 0 1.6.717 1.6 1.6 0 .883-.717 1.6-1.6 1.6zM17.6 22.401h-3.2c-.883 0-1.6-.717-1.6-1.6 0-.883.717-1.6 1.6-1.6h3.2c.883 0 1.6.717 1.6 1.6 0 .883-.717 1.6-1.6 1.6z",
  transform: "translate(-477 -343) translate(477 343) translate(25.6 12.9)"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#8D89AA",
  d: "M28.22.47c-.364-.305-.854-.436-1.314-.34l-25.6 4.8C.547 5.07 0 5.73 0 6.5v35.2c0 .768.547 1.43 1.306 1.571l25.6 4.8c.096.02.195.03.294.03.371 0 .733-.129 1.02-.369.369-.304.58-.758.58-1.232v-44.8c0-.477-.211-.928-.58-1.232z",
  transform: "translate(-477 -343) translate(477 343)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FAFAFA",
  d: "M22.003 29.448l-5.059-5.782 5.117-6.58c.544-.697.416-1.702-.279-2.246-.694-.544-1.699-.416-2.246.279l-4.74 6.093-3.993-4.564c-.585-.672-1.597-.732-2.256-.15-.665.582-.733 1.593-.15 2.256l4.4 5.03-4.461 5.735c-.544.697-.416 1.702.278 2.246.295.227.644.336.986.336.477 0 .947-.211 1.264-.617l4.08-5.249 4.653 5.316c.317.365.758.55 1.203.55.374 0 .749-.131 1.053-.397.665-.582.733-1.593.15-2.256z",
  transform: "translate(-477 -343) translate(477 343)"
}))));

var SvgExcel = function SvgExcel(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 49,
    viewBox: "0 0 52 49",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgExcel, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/excel.7907bc8b.svg";
export { ForwardRef as ReactComponent };